import { writable, type Writable } from 'svelte/store';
export enum DrawerKind {
    Info = 'Info',
    UpNext = 'UpNext',
}
export const openDrawer: Writable<DrawerKind> = writable(null);
